import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPauseComponent } from "./med-icon-pause.component";

@NgModule({
  declarations: [
    MedIconPauseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPauseComponent,
  ],
})
export class MedIconPauseModule { }
